import * as React from 'react';

export interface IFormSectionContext {
  enabled?: boolean;
  /**
   * Rimuove il margin-bottom dal messaggio di aiuto che è presente
   * sotto il campo.
   */
  removeHelpMargin?: boolean;
}

export const FormSectionContext = React.createContext<IFormSectionContext>({});

export const useFormSectionEnabled = () =>
  React.useContext(FormSectionContext)?.enabled;

export const useFormSectionContext = () => React.useContext(FormSectionContext);
